module.exports = __webpack_public_path__ + "img/0855-notification-circle-blue.4c6c2d72.svg";